import React from "react";
import "./style.scss";
import BanIcon from "@material-ui/icons/Block";
import UnassignedPickupsMarker from "../Markers/Dispatch/PickupMarkers/UnassignedPickupsMarker";
import RouteOnCard from "../../modules/Dispatch/RouteExecution/Recommendations/common/RouteOnCard";
import { withStyles } from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";

const styles = (theme) => ({
  iconContainer: {
    display: "inline-block",
    padding: "0px 8px",
    height: "27px",
  },
  banIcon: {
    verticalAlign: "middle",
    color: theme.errorTextColor,
  },
  bestRouteIcon: {
    verticalAlign: "inherit",
  },
  popupWidth: {
    width: "320px",
  },
  iconStyle: {
    fontSize: "27px",
    color: theme.gridTextColor,
  },
  swapIcon: {
    display: "inline-block",
    height: "27px",
  },
  stopNameLabel: {
    display: "inline-block",
    width: "100px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    textAlign: "center",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 12,
    lineHeight: "27px",
    color: theme.iconColor,
  },

  leftFabContainer: {
    margin: "0px 8px 0px 0px",
    display: "inline-block",
  },
  rightFabContainer: {
    margin: "0px 0px 0px 8px",
    display: "inline-block",
    verticalAlign: "bottom",
  },

  driverNameLabel: {
    width: "100px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    textAlign: "center",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 12,
    lineHeight: "27px",
    color: theme.iconColor,
    display: "inline-block",
  },
  messageStyle: {
    display: "inline-table",
    verticalAlign: "middle",
  },
  messageContainer: {
    width: "252px",
  },
});
const UnassignPickupMovePopupInfo = (props) => {
  const { classes, bestRoute, selectedStop } = props;
  const {
    stopNameLabel,
    iconContainer,
    rightFabContainer,
    driverNameLabel,
    leftFabContainer,
    iconStyle,
    popupWidth,
    swapIcon,
    bestRouteIcon,
    messageContainer,
    banIcon,
    messageStyle,
  } = classes;
  return bestRoute && bestRoute.routeId === null ? (
    <div className={`${messageContainer} popupInfo popupBGColor`}>
      <div>
        <BanIcon className={banIcon} />
        <div className={messageStyle}>
          Cannot assign a route from this Location
        </div>
      </div>
    </div>
  ) : (
    <div className={`popupInfo popupBGColor ${popupWidth}`}>
      <div align="left" className={leftFabContainer}>
        <div className={iconContainer}>
          <UnassignedPickupsMarker
            backgroundColor={theme.unassignPickupFillColor}
            borderColor={theme.markerStokeColor}
          />
        </div>
        <div className={stopNameLabel}>{selectedStop.shipperName}</div>
      </div>
      <div className={swapIcon}>
        <ArrowRightAltIcon className={`${iconStyle}`} />
      </div>
      <div align="right" className={rightFabContainer}>
        <div className={driverNameLabel}>{bestRoute.driverName}</div>
        <div className={`${iconContainer} ${bestRouteIcon}`}>
          <RouteOnCard color={bestRoute.color} />
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(UnassignPickupMovePopupInfo);
